
















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/figurePainting'

export default Vue.extend({
  name: 'FigurePaintingResult',
  computed: {
    ...mapGetters('figurePainting', ['painting']),
    ...mapGetters(['isWebViewMode'])
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.SUBMIT)
  },
  methods: {
    handleConfirm (): void {
      this.isWebViewMode
        ? postAppMessage(MessageHandlers.ON_UPLOAD_SUCCESS, true)
        : this.$router.push('/cart')
    }
  }
})
